import { render, staticRenderFns } from "./UnreasonableHospitalityArticle.vue?vue&type=template&id=02a095c5&"
import script from "./UnreasonableHospitalityArticle.vue?vue&type=script&lang=js&"
export * from "./UnreasonableHospitalityArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports